<div
  class="container content"
  [attr.id]="'event'"
  [attr.key]="refreshKey"
  (input)="markDirty()"
  (change)="markDirty()">
  <div class="row" *ngIf="event">
    <div class="col">
      <app-general
        [event]="event"
        [editable]="editable"
        (requestHeureDepartRecalculation)="onHeureDepartRecalculationRequested()">
      </app-general>

      <app-horaires
        [event]="event"
        [editable]="editable"
        (changed)="markDirty()"
        #eventHoraireMobile>
      </app-horaires>

      <app-equipe
        [event]="event"
        [editable]="editable"
        (changed)="markDirty()">
      </app-equipe>

      <app-transport
        [event]="event"
        [editable]="editable"
        (changed)="markDirty()">
      </app-transport>

      <app-trajet
        [event]="event"
        [editable]="editable"
        (changed)="markDirty()"
        (requestHeureDepartRecalculation)="onHeureDepartRecalculationRequested()">
      </app-trajet>

      <app-hebergement
        [event]="event"
        [editable]="editable"
        (changed)="markDirty()">
      </app-hebergement>

      <app-contacts
        [event]="event"
        [editable]="editable"
        (changed)="markDirty()">
      </app-contacts>

      <app-communication
        [event]="event"
        [editable]="editable"
        (changed)="markDirty()">
      </app-communication>

      <app-precision
        [event]="event"
        [editable]="editable">
      </app-precision>

    </div>
  </div>
</div>

<app-footer
  [event]="event"
  [editable]="editable"
  [hasChanges]="hasChanges"
  (updateEvent)="updateEvent()">
</app-footer>
